import React from "react";

// Components
import Modal from "../../modal/Modal";
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import Button from "../../modal/Button";
import Loader from "../../utils/Loader";
import SuccessWrap from "../../utils/error-success/SuccessWrap";

class UpdateFieldsConfirmationDialog extends React.PureComponent {
	render() {
		const { user, success, canSubmitInfo, dialogTitle, btnTranslations } = this.props;
		let buttons = [];

		// Deletion was a success
		if (success || !canSubmitInfo) {
			buttons = [
				{
					type: Button,
					text: btnTranslations.close,
					action: () => {
						this.props.handleClose();
					}
				}
			];
		}
		// Delete can still be confirmed
		else {
			buttons = [
				{
					type: Button,
					text: btnTranslations.cancel,
					action: () => this.props.handleClose(),
					disabled: this.props.inProgress
				},
				{
					type: Button,
					text: btnTranslations.yes,
					action: () => this.props.handleAction(user),
					disabled: this.props.inProgress
				}
			];
		}

		return this.props.show ? (
			<Modal title={dialogTitle} buttons={buttons}>
				{/* Loading */}
				{this.props.inProgress ? (
					<div className="pt2 pb2">
						<Loader />
					</div> // Show dialog content
				) : (
					<div>
						{success ? (
							<SuccessWrap animate={1}>{success}</SuccessWrap>
						) : (
							<React.Fragment>
								<div className="pb2">{this.props.children}</div>
								{!!this.props.errors &&
									this.props.errors &&
									this.props.showDialogErrors && (
										<ErrorWrap animate={1}>{this.props.errors}</ErrorWrap>
									)}
							</React.Fragment>
						)}
					</div>
				)}
			</Modal>
		) : null;
	}
}

export default UpdateFieldsConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/UpdateFieldsConfirmationDialog.js